export default __webpack_public_path__ + "static/media/no_criteria.e122564a.svg";